import {
    store,
    getContext,
    getElement,
    withScope,
    withSyncEvent,
} from "@wordpress/interactivity";

let searchTimeout = null;

const { state, actions } = store("dock11/job-filter", {
    state: {
        get isCheckedCategory() {
            const { selectedCategories, slug } = getContext();
            return selectedCategories.includes(slug);
        },
    },
    actions: {
        toggle() {
            const context = getContext();
            context.open = !context.open;
        },
        close() {
            const context = getContext();
            context.open = false;
        },
        closeOnEscape(event) {
            if (event.key !== "Escape") return;
            const context = getContext();
            if (context.open) context.open = false;
        },
        closeOnClickAway(event) {
            const { ref } = getElement();
            if (ref && !ref.contains(event.target)) {
                const context = getContext();
                if (context.open) context.open = false;
            }
        },
        handleSearchInput(event) {
            const context = getContext();
            context.searchTerm = event.target.value;

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(
                withScope(() => {
                    actions.emitFilterChange();
                }),
                300,
            );
        },
        handleEnterKey: withSyncEvent((event) => {
            if (event.key !== "Enter") return;
            event.preventDefault();
            actions.applyFilters();
        }),
        handleCategoryChange(event) {
            const context = getContext();
            const slug = context.slug;

            if (event.target.checked) {
                if (!context.selectedCategories.includes(slug)) {
                    context.selectedCategories.push(slug);
                }
            } else {
                context.selectedCategories = context.selectedCategories.filter(
                    (s) => s !== slug,
                );
            }
            actions.emitFilterChange();
        },
        emitFilterChange() {
            const context = getContext();
            document.dispatchEvent(
                new CustomEvent("job-filter-change", {
                    detail: {
                        search: context.searchTerm,
                        categories: context.selectedCategories,
                    },
                }),
            );
            actions.updateResults();
        },
        *updateResults() {
            const context = getContext();
            const queryEl = document.querySelector(".wp-block-query");
            if (!queryEl) return;

            const url = actions.buildUrl();
            window.history.replaceState({}, "", url.toString());

            try {
                queryEl.setAttribute("aria-busy", "true");
                const response = yield fetch(url.toString(), {
                    credentials: "same-origin",
                });
                if (!response.ok) return;
                const html = yield response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const newQuery = doc.querySelector(".wp-block-query");
                if (newQuery) {
                    document
                        .querySelector(".wp-block-query")
                        ?.replaceWith(newQuery);
                }
            } catch (e) {
                // Silently fail; user can still click Los to reload
            } finally {
                document
                    .querySelector(".wp-block-query")
                    ?.removeAttribute("aria-busy");
            }
        },
        applyFilters() {
            const context = getContext();
            context.open = false;
            window.location.href = actions.buildUrl().toString();
        },
        buildUrl() {
            const context = getContext();
            const url = new URL(window.location.href);

            if (context.searchTerm && context.searchTerm.trim() !== "") {
                url.searchParams.set(
                    "job-filter__input",
                    context.searchTerm.trim(),
                );
            } else {
                url.searchParams.delete("job-filter__input");
            }

            url.searchParams.delete("job-category");
            url.searchParams.delete("job-category[]");
            if (context.selectedCategories.length > 0) {
                url.searchParams.set(
                    "job-category",
                    context.selectedCategories.join(","),
                );
            }
            return url;
        },
    },
    callbacks: {
        init() {
            const context = getContext();
            const urlParams = new URLSearchParams(window.location.search);
            context.searchTerm = urlParams.get("job-filter__input") || "";
            const csv = urlParams.get("job-category");
            context.selectedCategories = csv
                ? csv
                      .split(",")
                      .map((v) => v.trim())
                      .filter(Boolean)
                : [];
        },
        focusInputOnOpen() {
            const context = getContext();
            const { ref } = getElement();
            if (context.open && ref) {
                const input = ref.querySelector("input");
                if (input) input.focus();
            }
        },
    },
});
